import { render, staticRenderFns } from "./LimitlessPageSidebarContent.vue?vue&type=template&id=72416a1a&"
import script from "./LimitlessPageSidebarContent.vue?vue&type=script&lang=js&"
export * from "./LimitlessPageSidebarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports